import dayjs from "dayjs";
import { string } from "yup";
import { SelectOptionsField } from "./selectOptionsField/SelectOptionsField";
import { SelectExtrasField } from "./selectExtrasField/SelectExtrasField";
import { FieldComponents } from "../../forms/FormKit";
import { SignatureFields } from "./signatureFields/SignatureFields";
import { createPropertyFieldForRegistration, shouldDisplayField } from "../../forms/propertyFields";
import { useOrganisation } from "../../providers/OrganisationProvider";
import { useFormState } from "react-hook-form";

export const AthleteRegistrationForm = ({ entry, index, control, getValues, displayName, options, registrationOptions, captureFields, paymentOptions, isSeriesRegistration }) => {
    const individualDivisions = options.filter(option => !option.isTeams);
    const organisation = useOrganisation();
    const { defaultValues } = useFormState({ control });

    const captureProperties = captureFields || [],
        signatureFields = captureProperties.filter(p => p.type === "signature" && p.level === "registration" && !!p.config.docusealTemplateSlug),
        customFields = captureProperties.filter(p => p.type !== "signature" && (p.level === "athlete" || p.level === "registration"));

    const fields = [
        displayName && {
            name: `athletes.${index}.name`,
            type: "text",
            label: "Full name (first and last name)",
            validation: string().required("The athlete needs a name."),
            inputProps: { autoFocus: true }
        },
        {
            name: `athletes.${index}.dob`,
            label: "Date of birth",
            type: "date",
            validation: string().required("Surely they were born?").nullable().required("Surely they were born?"),
            inputProps: { maxDate: dayjs().toDate() }
        },
        ...customFields.filter(shouldDisplayField({ athlete: entry })).map(property => createPropertyFieldForRegistration(property,
            `athletes.${index}.${property.level === "athlete" ? "properties" : "registration_properties"}`,
            true,
            entry,
            defaultValues.initial_athletes.find(a => a.id === entry.id),
            organisation.contactEmail
        )),
        {
            name: `athletes.${index}.registrations_attributes`,
            label: isSeriesRegistration ? "Membership options" : "Divisions",
            component: SelectOptionsField,
            options: isSeriesRegistration ? options : individualDivisions,
            registrationOptions,
            paymentOptions,
            index
        },
        (paymentOptions?.extras?.length > 0) && {
            name: `athletes.${index}.extras`,
            label: "Purchase extras",
            component: SelectExtrasField,
            paymentOptions
        },
        signatureFields.length > 0 && {
            name: `athletes.${index}.signature_fields`,
            label: "Documents to sign",
            basePath: `athletes.${index}.registration_properties`,
            component: SignatureFields,
            athlete: entry,
            isSeriesRegistration,
            signatureFields,
        }
    ];

    return <FieldComponents fields={fields} control={control} getValues={getValues} />;
};
